export default __webpack_public_path__ + "static/media/SWT0090.34I-21568_-16377_0.83a809c6.jpg";